import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, TextField, TextFieldProps } from '@mui/material';
import { memo } from 'react';
import { validateDurationValue } from '../../utils';
import * as SX from './sx';
import type { DurationFilterInputProps as Props } from './types';

export const DurationFilterInput = memo(
  ({
    className,
    icon,
    placeholder,
    onChange,
    value,
    limit,
    time,
    error,
  }: Props) => {
    const InputProps: TextFieldProps['InputProps'] = {
      startAdornment: icon && <Icon name={icon} size={20} />,
    };

    const handleChange: TextFieldProps['onChange'] = (e) => {
      const isValid = validateDurationValue(e.target.value, limit, time);
      if (isValid) {
        onChange(limit, time, e.target.value);
      }
    };

    return (
      <Box
        className={classnames('DurationFilterInput', className)}
        display="flex"
        flex={1}
        justifyContent="center"
        alignItems="center"
        sx={SX.root}
      >
        <TextField
          error={error}
          autoComplete="off"
          type="number"
          size="xsmall"
          fullWidth
          placeholder={placeholder}
          InputProps={InputProps}
          inputProps={{ min: 1, max: 100, sx: { lineHeight: 1 } }}
          onChange={handleChange}
          value={value?.[limit]?.[time]}
        />
      </Box>
    );
  }
);

DurationFilterInput.displayName = 'DurationFilterInput';
